/* eslint-disable @typescript-eslint/no-unsafe-argument */
import React from "react";

import { Box, Flex, Text, Divider } from "flicket-ui";

import { useRouter } from "next/router";
import { Footer, PageContainer } from "~components";
import { useOrganization } from "~hooks";
import { EventQuery, LandingPage } from "~graphql/sdk";
import BackLink from "../events.BackLink";
import Section from "../events.Section";
import EventCTACard from "../events.EventCTACard";
import EventInformation from "../events.EventInformation";
import MainCTA from "../events.MainCTA";
import ReleaseCodes from "../events.ReleaseCodes";
import useShowReleaseCodes from "~features/events/hooks/useShowReleaseCodes";

export type DesktopDetailProps = {
  event: EventQuery["event"];
  showSeatsCTA: boolean;
  releaseIsActive: boolean;
  isSinglePage: boolean;
};

export const Desktop = ({
  event,
  isSinglePage,
  showSeatsCTA,
  releaseIsActive,
}: DesktopDetailProps) => {
  const {
    title,
    logo,
    backgroundImage,
    backgroundImageFullPage,
    isWaitlistAvailable,
    season,
    enableReleaseCodes,
  } = event;

  const router = useRouter();
  const { organization } = useOrganization();
  const isUnlistedRelease = router.query.slug ? true : false;

  const showPresaleRegistrationCTA =
    !showSeatsCTA && !isUnlistedRelease && isWaitlistAvailable;

  const showReleaseCodes = useShowReleaseCodes(enableReleaseCodes);

  return (
    <PageContainer
      backgroundImage={backgroundImage}
      backgroundImageFullPage={backgroundImageFullPage}
      bannerImage={logo}
      titleText={title}
      footer={<Footer />}
    >
      <BackLink
        isSinglePage={isSinglePage}
        tourId={
          organization.landingPage === LandingPage.Tours && season
            ? season.id
            : null
        }
      />
      {/* Title */}
      <Section mt={4} mb={6}>
        <Text
          as={"h1"}
          color="N800"
          fontWeight="extraBold"
          fontSize={9}
          lineHeight={"56px" as any}
        >
          {title}
        </Text>
      </Section>

      <Section>
        <Flex justifyContent={"space-between"} style={{ gap: "65px" }}>
          <Box flex={2}>
            <Divider mb={5} />
            <EventInformation event={event} />
          </Box>
          <Box flex={"0 0 370px"}>
            {showSeatsCTA ? (
              <EventCTACard>
                <Box>
                  <MainCTA event={event} releaseIsActive={releaseIsActive} />
                  {showReleaseCodes ? (
                    <>
                      <Divider my={2} />
                      <ReleaseCodes event={event} />
                    </>
                  ) : null}
                </Box>
              </EventCTACard>
            ) : null}
            {showPresaleRegistrationCTA ? (
              <EventCTACard title="Register to get early access to presale tickets!">
                <Box>
                  <MainCTA event={event} releaseIsActive={releaseIsActive} />
                  {showReleaseCodes ? (
                    <>
                      <Divider my={2} />
                      <ReleaseCodes event={event} />
                    </>
                  ) : null}
                </Box>
              </EventCTACard>
            ) : null}
          </Box>
        </Flex>
      </Section>
    </PageContainer>
  );
};
